module.exports = __webpack_public_path__ + "img/Icon_completo.fc23aea5.png";